export default "__VITE_ASSET__DHKrcU8C__"